module.exports = __webpack_public_path__ + "e7ec1db0c2bc255d319082dd40f103e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/meta_2023_chart.png
// module id = 1694
// module chunks = 0